import React from 'react';

import { Dropdown, Icon, Button } from 'antd';

import './index.less';


export default class ActionMenu extends React.Component {

  onClick = event => {
    event.preventDefault();
    event.stopPropagation();
  }

  render () {

    const {overlay, ignoreOnClick, iconType} = this.props;

    if (ignoreOnClick === true) {
      return <Dropdown overlay={overlay} onClick={this.onClick}>
          <Button>
            <Icon type={iconType}/>
          </Button>
        </Dropdown>
      }
    return <Dropdown overlay={overlay}>
      <Button>
        <Icon type={iconType}/>
      </Button>
    </Dropdown>
  }
}



// WEBPACK FOOTER //
// ./src/components/ActionMenu/index.jsx